import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDetailsDialogs } from './../dialogs/error-details-dialog/error-details-dialogs.enum';
import { ErrorDetailsDialogComponent } from '../dialogs/error-details-dialog/error-details-dialog.component';

@Component({
  selector: 'cl-error-alert',
  templateUrl: './cl-error-alert.component.html',
  styleUrls: ['./cl-error-alert.component.scss']
})

export class ClErrorAlertComponent {
  @Input() errorMessage: string;
  @Input() externalStyles: any = {};
  @Input() mode: ErrorDetailsDialogs;
  @Input() details: any = {};
  @Input() id: string = 'theAlert';

  constructor(public translateSvc: TranslateService,
    public dialog: MatDialog) {
  }

  openDetailsDialog() {
    this.dialog.open(ErrorDetailsDialogComponent, { data: { mode: this.mode, details: this.details } });
  }

}